import axios from "axios";
import headers from "./Header";

class SettingService {
	getMsSettings() {
		let url = "/api/metadata-statistik/settings"
		return axios.get(url, {
			headers: headers(),
		});
	}
	getSdsSettings() {
		let url = "/api/standar-data-statistik/settings"
		return axios.get(url, {
			headers: headers(),
		});
	}
}
export default new SettingService();